import { htmlDecode } from 'utils/general'

export default {
  props: [
    'product',
    'variants',
    'selectedVariant'
  ],
  data () {
    return {
      currentSelectedVariant: this.selectedVariant
    }
  },
  mounted () {
    if (this.product && this.product.tags) {
      const upsellTag = this.product.tags.find(tag => tag.startsWith('Upsell Default:'))
      if (upsellTag) {
        const variantId = upsellTag.replace('Upsell Default:', '').trim()
        const upsellVariant = this.sizeVariants.find(v => v.id.toString() === variantId)
        if (upsellVariant && upsellVariant.available) {
          this.selectSizeVariant(upsellVariant)
        }
      }
    }
  },
  computed: {
    hasSizeVariants () {
      return this.sizeVariants.length > 0
    },
    sizeVariants () {
      if (this.variants && this.variants.length > 0) {
        return this.variants.filter(variant => variant.available)
      }

      if (this.product && this.product.variants && this.product.optionNames && this.product.optionNames.includes('Size')) {
        return this.product.variants.filter(variant => variant.available)
      }

      return []
    },
    showTitle () {
      return this.sizeVariants.length > 1
    },
    sizeDropdownOptions () {
      return this.sizeVariants.filter(variant => variant.available).map(variant => ({
        label: this.getSizeVariantText(variant),
        value: variant.id.toString(),
        disabled: !variant.available
      }))
    },
    selectedSizeOption () {
      if (!this.currentSelectedVariant) {
        return this.sizeVariants.length > 0 ? {
          label: this.getSizeVariantText(this.sizeVariants[0]),
          value: this.sizeVariants[0].id.toString()
        } : null
      }
      return {
        label: this.getSizeVariantText(this.currentSelectedVariant),
        value: this.currentSelectedVariant.id.toString()
      }
    }
  },
  watch: {
    selectedVariant (newVariant) {
      this.currentSelectedVariant = newVariant
    }
  },
  methods: {
    getSizeVariantText (variant) {
      const title = htmlDecode(variant.title)

      if (title.includes(' / ')) {
        const parts = title.split(' / ')
        for (let i = 1; i < parts.length; i++) {
          const part = parts[i].trim()
          if (part && !part.toLowerCase().includes('color') && !part.toLowerCase().includes('shade')) {
            return part
          }
        }
      }

      return title
    },
    isSelectedVariant (variant) {
      if (!this.currentSelectedVariant) {
        return this.sizeVariants.length > 0 && variant.id === this.sizeVariants[0].id
      }
      return variant.id === this.currentSelectedVariant.id
    },
    selectSizeVariant (variant) {
      if (!variant.available) return

      this.currentSelectedVariant = variant
      this.$emit('size-selected', variant)
    },
    onSizeDropdownChange (selectedOption) {
      const selectedVariant = this.sizeVariants.find(variant =>
        variant.id.toString() === selectedOption.value
      )

      if (selectedVariant) {
        this.currentSelectedVariant = selectedVariant
        this.$emit('size-selected', selectedVariant)
      }
    }
  },
  template: `
    <div class="product-card-size-picker__wrapper" v-if="hasSizeVariants">
      <div class="product-card-size-picker__swatches" v-if="sizeVariants.length <= 2">
        <button
          v-for="(variant, index) in sizeVariants"
          :key="variant.id"
          class="product-card-size-picker__swatch"
          :class="{
            'active': isSelectedVariant(variant),
            'unavailable': !variant.available
          }"
          :disabled="!variant.available"
          @click="selectSizeVariant(variant)"
          :aria-label="getSizeVariantText(variant)"
          type="button">
          <span class="product-card-size-picker__swatch-text" v-text="getSizeVariantText(variant)"></span>
        </button>
      </div>

      <div class="product-card-size-picker__dropdown" v-else>
        <div
          is="dropdown-custom"
          base-component="dropdown-custom"
          :choices="sizeDropdownOptions"
          :selected="selectedSizeOption"
          menu-label="size-dropdown"
          @change="onSizeDropdownChange"
          class="dropdown-custom product-card-size-picker__dropdown-select">
        </div>
      </div>
    </div>
  `
}
